import { config } from "~/data/config";
import { Repo } from "../apis/repo";
import { RequestData } from "../apis/repo_base";
import {
  SimulatedTransactionResponse,
  SimulateTransactionRequest,
} from "../types/brand";
import {
  OrderDetails,
  RedemptionParams,
  RedemptionResponse,
  ShareableCoupon,
} from "../types/order";

const defaultMockDelayPromise = (ms: number = 2000) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });

export class AxisMockRepo extends Repo {
  constructor(fetch: <T>(request: RequestData) => Promise<T>) {
    super(fetch);
  }

  async simulate(
    request: SimulateTransactionRequest
  ): Promise<SimulatedTransactionResponse> {
    return {
      nextCursor: null,
      data: [
        {
          paymentSource: "PG_AND_WALLET_AND_COINS",
          coinToInrConversionRatio: 1,
          totalRequiredCoins: 960.0,
          totalRedeemableCoins: 0.0,
          planType: "BASIC",
          redemptionAmount: 1000,
          requiredDeposit: 960.0,
          dueAmount: 908.0,
          discountDetails: {
            storeRewardType: "PREPAID",
            totalDiscount: {
              amount: 40.0,
              percentage: 4.0,
            },
            hubbleBaseDiscount: {
              amount: 40.0,
              percentage: 4.0,
            },
            hubbleWalletDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            couponDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            referralDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            coinDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            // offerConstructDiscount: undefined,
            code: undefined,
          },
          additionalCharges: {
            transactionFees: {
              amount: 0,
              percentage: 0.0,
            },
            tdsCharges: {
              amount: 0,
              percentage: 0.0,
            },
          },
          paymentRoute: "PG",
          paymentMode: "UPI",
          routeStatus: "ACTIVE",
          denominationDetails: [
            {
              denomination: 1000,
              quantity: 1,
            },
          ],
        },
        {
          paymentSource: "PG_AND_WALLET_AND_COINS",
          coinToInrConversionRatio: 1,
          totalRequiredCoins: 980.0,
          totalRedeemableCoins: 0.0,
          planType: "BASIC",
          redemptionAmount: 1000,
          requiredDeposit: 980.0,
          dueAmount: 980.0,
          discountDetails: {
            storeRewardType: "PREPAID",
            totalDiscount: {
              amount: 20.0,
              percentage: 2.0,
            },
            hubbleBaseDiscount: {
              amount: 40.0,
              percentage: 4.0,
            },
            hubbleWalletDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            couponDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            referralDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            coinDiscount: {
              amount: 0,
              percentage: 0.0,
            },
            // offerConstructDiscount: undefined,
            code: undefined,
          },
          additionalCharges: {
            transactionFees: {
              amount: 20.0,
              percentage: 2.0,
            },
            tdsCharges: {
              amount: 0,
              percentage: 0.0,
            },
          },
          paymentRoute: "PG",
          paymentMode: "CARD",
          routeStatus: "ACTIVE",
          denominationDetails: [
            {
              denomination: 1000,
              quantity: 1,
            },
          ],
        },
      ],
    };
  }

  async initiateRedemption(
    params: RedemptionParams,
    headers?: Record<string, string>
  ): Promise<RedemptionResponse> {
    const path = "v2/redemptions/provider/pg/initiate";
    await defaultMockDelayPromise();
    return {
      id: "01JYEAN9CC0136T2V4GMWM9N7K",
      paymentRoute: "PG",
      planType: "BASIC",
      amount: 1000,
      depositPaymentDetails: {
        id: "01JYEAN9WQACPBJ2S3N3Y8ATHJ",
        amount: 0.0,
        status: "SUCCESS",
        provider: "",
        otpToken: "",
        providerMetadata: {
          customerId: "",
          providerOrderId: "",
        },
      },
      storeOrderDetails: {
        id: "01JYEAN9NC3E6PJW86NNA7BQKX",
        amount: 1000,
        status: "PROCESSING",
      },
      refundDetails: {
        id: "",
        amount: 0.0,
        status: "SUCCESS",
      },
    };
  }

  async getStoreOrderDetails(
    orderId: string,
    headers?: Record<string, string>
  ): Promise<OrderDetails> {
    await defaultMockDelayPromise();
    return {
      id: "01JYEAN9NC3E6PJW86NNA7BQKX",
      amount: 1000,
      date: "2025-06-23",
      status: "COMPLETED",
      orderProductDetails: {
        productType: "VOUCHER",
        productId: "01GMAVS2CHXR0XP1BZSTA9A44K",
        voucherProductTitle: "Amazon shopping",
        voucherProductLogoUrl:
          "https://assets.myhubble.money/brand-assets/logo-images-wp/amazon-logo.webp",
        voucherProductPlainLogoUrl:
          "https://assets.myhubble.money/brand-assets/wdmark-images-wp/amazon-wdmark.webp",
        voucherProductBackgroundColor: "#233448",
        voucherProductSummary: {
          totalVouchers: 1,
          totalAmount: 1000.0,
          totalBalance: 1000.0,
          activeVouchersCount: 1,
        },
        vouchers: [
          {
            id: "01JYEANJEEVV2ZYFQDSKKV8XTR",
            status: "ACTIVE",
            voucherType: "PIN_SECURED_CARD",
            cardNumber: "8090920019564144",
            cardPin: "217691",
            amount: 1000.0,
            balance: 1000.0,
            expiryDate: "2026-06-23",
            generatedDate: "2025-06-23",
            generatedDateTime: "2025-06-23T12:02:08.248421",
            voucherMetadata: {
              title: "Amazon shopping",
              cardImageUrl: "",
              tncUrl: "",
              tncResId: "voucher-tnc/amazon.md",
              heroImageUrl:
                "https://assets.myhubble.money/brand-assets/hero-images-wp/amazon-hero.webp",
              cardBackgroundColor: "#233448",
              howItWorksVideoUrl:
                "https://gullak-assets.s3.ap-south-1.amazonaws.com/brand-images/how-it-works-ss/Amazon_NEW_HTU.png",
              howItWorksCtaUrl: "",
              howItWorksStepsAvailable: false,
              canBalanceBeFetched: true,
              shareText:
                "Congratulations!\uD83C\uDF89\n\nYour friend has gifted\uD83C\uDF81 you a *Amazon shopping Brand card* worth *₹1000* using Hubble. Use this card number & PIN on your next purchase at Amazon shopping. \n\n✅ *Card Number:* 8090920019564144\n✅ *Card Pin:* 217691\n\nYou too can grab your favourite brand card on Hubble & get *up to 10% off* instantly!",
              addVoucherBrandPageUrl:
                "https://www.amazon.in/apay-products/apv/landing",
              addVoucherBrandPageImageUrl: null,
              voucherRedemptionType: "PIN_NO_SECURED",
              plainLogoUrl:
                "https://assets.myhubble.money/brand-assets/wdmark-images-wp/amazon-wdmark.webp",
              shareImageUrl:
                "https://gullak-assets.s3.ap-south-1.amazonaws.com/share-wa-brand-images/Amazon.jpg",
              howToUseDetailedStepsAvailable: true,
              isVoucherAssured: false,
            },
            brandId: "01GMAVS2CHXR0XP1BZSTA9A44K",
            orderId: "01JYEAN9NC3E6PJW86NNA7BQKX",
          },
        ],
        variantTitle: null,
        variantSubtext: null,
      },
      orderSavings: {
        usedRewardAmount: 0,
        discountAmount: 1000.0,
        totalCoinEarnings: 0,
      },
    };
  }
  async getShareableCoupon(
    headers?: Record<string, string>
  ): Promise<ShareableCoupon | null> {
    throw new Error("Not implemented");
  }
}
